import { render, staticRenderFns } from "./PatentDivisionForm.vue?vue&type=template&id=28b0d002&"
import script from "./PatentDivisionForm.vue?vue&type=script&lang=js&"
export * from "./PatentDivisionForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentDivisionForm.vue?vue&type=style&index=0&id=28b0d002&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports